$(document).ready(function(){
  $("#join-us").click(function(){
    $(".newsletterbox").show();   
    $("#mask").show();
  });
  $("#nlbx").click(function(){
    $(".newsletterbox").hide();
    $("#mask").hide();
  });


  function readCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
    }
    return "";
  } 

  var visit=readCookie('best_shop');
  if(visit!='user'){
    var now = new Date();
    var time = now.getTime();
    time += (90*24*60*60*1000);
    now.setTime(time);
    document.cookie = 
      'best_shop=user' + 
      '; expires=' + now.toUTCString();

    setTimeout(function(){ 
      $(".newsletterbox").show();   
      $("#mask").show();
    }, 2500);
  }
  
  $(document).mouseup(function (e)
{
    var container = $(".newsletterbox");

    if (!container.is(e.target) // if the target of the click isn't the container...
        && container.has(e.target).length === 0) // ... nor a descendant of the container
    {
        container.hide();
      $("#mask").hide();
    }
});
  
});